import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/css/App.css';
import Header from './templates/Header';
import Footer from './templates/Footer';
import HomeContent from './content/HomeContent';
import Forms from './content/Forms';
import Impressum from './content/Impressum';
import Datenschutz from './content/Datenschutz';
import JobDetailView from './anzeigen/JobDetailView';
import Backend from './backend/Backend';

function FrontendRoutes() {
    return (
        <Routes>
            <Route path="/" element={<HomeContent />} />
            <Route path="/:joburl" element={<JobDetailView />} />
            <Route path="/jetzt-bewerben/:jobid" element={<Forms />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
    );
}

function App() {
    const location = useLocation();
    const isFrontend = !location.pathname.startsWith('/backend');

    if (isFrontend) {
        return (
            <div className="App">
                <Header/>

                <FrontendRoutes/>
                <Footer/>
            </div>
        );
    } else {
        return (
            <div className="App">

                <Backend />
            </div>
        );
    }
}

export default App;
